import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { environment } from '../environments/environment';

/**
 * Loads per-language translation dictionaries from src/assets/i18n/{lang}.json.
 * Uses a relative path (no leading slash) so the app works when hosted under a
 * sub-path on the IIS/CSR estate (SmarterASP, Conetix).
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    // Cache-bust per build: assets/i18n/*.json are NOT fingerprinted and the IIS/CSR
    // hosts serve them with a one-year max-age, so without a version query a new build's
    // translations stay stale in the browser. environment.build.number changes every build.
    return this.http.get<Translation>(`assets/i18n/${lang}.json?v=${environment.build.number}`);
  }
}
